import React from 'react';
import styles from './index.less';
import classNames from 'classnames/bind';
import { Popover } from '@bedrock/components';
import { CreditCards } from '@bedrock/icons-react';
import { ChannelSupplierBankDto } from '#services/api';

const cx = classNames.bind(styles);

interface Props {
  value: ChannelSupplierBankDto
  type: 'renderLabel' | 'renderSelectedItem' | 'card';
  style?: React.CSSProperties;
  className?: string;
}

const BankCard = (props: Props) => {
  const { value, type, style, className } = props;  
  const items = [
    {
      label: '银行账号',
      key: 'bank_account',
      value: value?.bank_account,
      show: true,
    },
    {
      label: '账户名称',
      key: 'bank_account_name',
      value: value?.bank_account_name,
      show: true,
    },
    {
      label: '银行及分支行',
      value: value?.bank_branch_name,
      key: 'banks_and_branches',
    },
    {
      label: '银行地址',
      value: value?.bank_country_name + value?.bank_province + value?.bank_city,
      key: 'bank_address',
    },
    {
      label: 'Swift Code',
      value: value?.swift_code,
      key: 'swift_code',
    },
  ];

  const renderHoverCard = () => {
    return (
      <div className={cx('bank-card-hover-card__container')}>
        <div>
          <CreditCards />
        </div>
        <div className={cx('bank-card-hover-card__container__content')}>
          {
            items.map((item, index) => {
              return (
                <div className={cx('bank-card-hover-card__item')} key={index}>
                  <div className={cx(item.key === 'bank_account' ? 'black-bold-text' : 'bank-card-hover-card__item-label')}>{item.label}：</div>
                  <div className={cx(item.key === 'bank_account' ? 'black-bold-text' : 'bank-card-hover-card__item-value')}>{item.value}</div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  if (type === 'renderLabel') {
    return (
      <div style={style} className={cx('bank-card-render-label__container', className)}>
        {
          items.map((item, index) => {
            return (
              <div className={cx('bank-card-render-label__item')} key={index}>
                <div className={cx(item.key === 'bank_account' ? 'black-bold-text' : 'bank-card-render-label__item-label')}>{item.label}：</div>
                <div className={cx(item.key === 'bank_account' ? 'black-bold-text' : 'bank-card-render-label__item-value')}>{item.value}</div>
              </div>
            )
          })
        }
      </div>
    )
  }

  if (type === 'renderSelectedItem') {
    return (
      <div style={style} className={cx('render-selected-item__container', className)}>
        {
          items.map((item, index) => {
            if (!['bank_account', 'bank_account_name'].includes(item.key)) {
              return null
            }
            return (
              <div className={cx('render-selected-item__item')} key={index}>
                <div className={cx('render-selected-item__item-label')}>{item.label}：</div>
                <div className={cx(item.key === 'bank_account' ? '' : 'render-selected-item__item-value')}>{item.value}</div>
              </div>
            )
          })
        }
      </div>
    )
  }

  if (type === 'card') {
    return <Popover content={renderHoverCard()}>
      <div style={style} className={cx('card__container', className)}>
        {
          items.map((item, index) => {
            if (!['bank_account', 'bank_account_name'].includes(item.key)) {
              return null
            }
            return (
              <div className={cx('card__item')} key={index}>
                <div className={cx('card__item-label')}>{item.label}：</div>
                <div className={cx(item.key === 'bank_account' ? 'card__item-value-black' : 'card__item-value')}>{item.value}</div>
              </div>
            )
          })
        }
      </div>
    </Popover>
  }

  return null;
}

export default BankCard;
